import { useState } from 'react';
import { Stack, Title, TextInput, Button, Group, Text, Flex } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useNavigate } from 'react-router-dom';
import { useKiosk } from '../../context/KioskContext/KioskContext';
import { api } from '../../wheel-api/client';
import { BRAND } from '../../theme/kioskTheme';

export function CheckIn() {
  const [phone, setPhone] = useState('');
  const [tag, setTag] = useState('');
  const [loading, setLoading] = useState(false);
  // Dos personas comparten cada numero de caravana (gemelos §2): cuando pasa,
  // hay que preguntarle a la persona cual de las dos es.
  const [gemelos, setGemelos] = useState(null);
  const { setAttendee, setPhoneRaw, setSpinResult, setDestinoFinal, flujo, rutas } = useKiosk();
  const navigate = useNavigate();

  const soloDigitos = v => v.replace(/\D/g, '');

  async function continuar() {
    if (!phone && !tag) {
      notifications.show({ message: 'Poné tu WhatsApp o tu número de caravana' });
      return;
    }
    setLoading(true);
    try {
      const r = await api.checkin({
        phone: phone || undefined,
        tagNumber: tag || undefined,
      });

      if (r.multiple) {
        setGemelos(r);
        setLoading(false);
        return;
      }

      if (!r.found) {
        setPhoneRaw(phone);
        navigate(rutas.ficha);
        return;
      }

      setAttendee(r.attendee);
      setPhoneRaw(phone);

      // Ya giró hoy, pero puede no tener caravana todavía: igual pasa por el
      // paso de caravana, que después la lleva al premio en vez de al giro.
      if (flujo === 'RULETA' && r.spunToday) {
        setSpinResult({ alreadySpun: true, ...r.todaySpin, name: r.attendee.name });
        setDestinoFinal('/kiosk/premio');
      }
      navigate(rutas.destino);
    } catch (err) {
      const MSG = {
        INVALID_PHONE: 'Ese número de WhatsApp no parece válido. Revisalo.',
        INVALID_TAG_NUMBER: 'Revisá el número de caravana.',
      };
      notifications.show({
        message: MSG[err.code] || 'No pudimos conectarnos. Probá de nuevo.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  }

  async function elegir(attendeeId) {
    setLoading(true);
    try {
      const r = await api.checkin({ attendeeId });
      setAttendee(r.attendee);
      if (flujo === 'RULETA' && r.spunToday) {
        setSpinResult({ alreadySpun: true, ...r.todaySpin, name: r.attendee.name });
        setDestinoFinal('/kiosk/premio');
      }
      navigate(rutas.destino);
    } catch {
      notifications.show({ message: 'No pudimos continuar. Probá de nuevo.', color: 'red' });
      setLoading(false);
    }
  }

  if (gemelos) {
    return (
      <Stack justify="center" align="center" style={{ flex: 1 }} px="10%" gap="xl">
        <Stack align="center" gap={4}>
          <Title order={2} ta="center" c="forvet.7" style={{ fontSize: 'clamp(22px, 3.6vh, 38px)' }}>
            LA CARAVANA {gemelos.tagNumber} LA TIENEN DOS PERSONAS
          </Title>
          <Text size="xl" c="forvet.6" ta="center">Tocá tu nombre</Text>
        </Stack>

        <Group gap="lg" justify="center">
          {gemelos.opciones.map(o => (
            <Button key={o._id} h={88} w={260} loading={loading} onClick={() => elegir(o._id)}>
              {o.nombre}
            </Button>
          ))}
        </Group>

        <Button variant="subtle" h={56} onClick={() => { setGemelos(null); setTag(''); }}>
          Ninguno de los dos
        </Button>
      </Stack>
    );
  }

  return (
    <Stack justify="center" style={{ flex: 1 }} px="10%" gap="xl">
      <Title order={2} ta="center" c={BRAND.forvetNavy} style={{ fontSize: 'clamp(24px, 4vh, 40px)' }}>
        ¿YA NOS DEJASTE TUS DATOS EN ESTOS DÍAS?
      </Title>

      <TextInput
        label="Tu WhatsApp"
        placeholder="351 123 4567"
        inputMode="numeric"
        leftSection={<Text size="xl" fw={700} c={BRAND.forvetNavy}>+54 9</Text>}
        leftSectionWidth={90}
        value={phone}
        onChange={e => setPhone(soloDigitos(e.currentTarget.value))}
        disabled={Boolean(tag)}
      />

      <Flex justify='start' align='start' direction='column'>
        <Text ta="center" c={BRAND.forvetNavy} size="lg" mb="xs">o tu número de caravana</Text>
        <TextInput
          placeholder="137"
          inputMode="numeric"
          w={200}
          value={tag}
          onChange={e => setTag(soloDigitos(e.currentTarget.value))}
          disabled={Boolean(phone)}
        />
      </Flex>

      <Group grow>
        <Button loading={loading} onClick={continuar}>CONTINUAR</Button>
        <Button variant="outline" onClick={() => { setPhoneRaw(phone); navigate(rutas.ficha); }}>
          ES MI PRIMERA VEZ
        </Button>
      </Group>
    </Stack>
  );
}